export default "__VITE_ASSET__jRKYoNVO__"